module.exports = __webpack_public_path__ + "img/mapka-min.b28576c0.svg";